import { Component, AfterViewInit, OnInit, ViewChild, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first, map } from 'rxjs/operators';

import { AlertService, ExamService } from '../_services';
import { Globals } from '../_helpers';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { AngularEditorConfig } from '@kolkov/angular-editor';
//import { VoiceRecognitionService } from '../service/voice-recognition.service'
import { HttpHeaders, HttpClient } from '@angular/common/http';


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}



const reader = new FileReader();
const formData: FormData = new FormData();



@Component({
  selector: 'app-descriptive-exam',
  templateUrl: './typing-simulation.component.html',
  styleUrls: ['./typing-simulation.component.css'],
  //providers: [VoiceRecognitionService]
})

export class TypingSimulationComponent implements OnInit {
  @ViewChild('optionsubmitSwal') private optionsubmitSwal: SwalComponent;
  @ViewChild('optionsubmitconfirmSwal') private optionsubmitconfirmSwal: SwalComponent;
  @ViewChild('examsubmitconfirmSwal') private examsubmitconfirmSwal: SwalComponent;
  @ViewChild('timeoverSwal') private timeoverSwal: SwalComponent;
  @ViewChild('noanyanswerSwal') private noanyanswerSwal: SwalComponent;
  @ViewChild('mandatorySwal') private mandatorySwal: SwalComponent;
  @ViewChild('inputFile') attachInputVariable: ElementRef;
  @ViewChild('imagesizeSwal') imagesizeSwal: SwalComponent;
  @ViewChild('docsizeSwal') docsizeSwal: SwalComponent;
  @ViewChild('LanguageSwal') LanguageSwal: SwalComponent;

 editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '25rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['link', 'unlink', 'image', 'video'], ['insertImage', 'insertVideo']
    ]

  };

  public alertOption: SweetAlertOptions = {};


  matcher = new MyErrorStateMatcher();

  @HostListener('window:keyup', ['$event'])
  onKeyupHandler(event: KeyboardEvent) {
    /*console.log(event.keyCode);*/
      if (event.keyCode === 123 || event.keyCode === 67 ||event.keyCode === 17)
          //this.autoSubmitAnswers('manual');
          /*console.log(event.keyCode);*/
          event.stopPropagation();
  }
  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
  event.preventDefault();
  }  
  studentName: string = '';
  studentCode: string = '';
  optionIndexText = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
  answerdObj = {};
  notSubmitObj = [];
  answeredQuestObj = [];
  questArr = [];
  loading = false;
  indexClasses: string;
  timershow: string;
  returnUrl: string;
  maxMarks: number;
  duration: number = 0;
  type: string;
  totalQuestion: number;
  question: string;
  questionInst: string;
  index: number = 1;
  answer_id: number;
  question_id: number;
  deficulty_lebel: number = 0;
  userData = {};
  settings = {};
  options = [];
  distance: any;
  totalAnswered: number = 0;
  totalSubmited: number = 0;
  totalVisited: number = 0;
  totalNotAnswered: number = 0;
  interval;
  intervaltime;
  settime;
  isPause = false;
  isResetBtn = false;
  visitedQuesObj = {};
  isSubmit = false;
  isPauseBtn = false;
  instructions = [];
  nativeWindow: any;
  totalTimeTake: number = 0;
  timeTaken: number = 0;
  timeRemain: number = 0;
  totalExamTime;
  prevques = [];

  isMedia = false;
  qaudioUrl: string = '';
  qvideoUrl: string = '';
  qimageUrl: string = '';
  ssclogo: string = '';
  surveyUrl: string = '';
  isPicTaken;
  imagePath;
  noofpic: number = 0;
  isDone = true;
  isSpeech = true;
  speechLang = 'en-GB';
  prevIndex: number = 1;
  lock_status = 0;
  spendTime: number = 0;
  radioSelected: number;
  src
  imgs
  canvase = false;
  anstype: number = 1;
  ans: string
  attach: number
  attachfile: string
  attach_type: number
  fileToLoad: File = null;

  textValue: string = '';
  remain_minute: number;
  freezestatus: number = 0;
  isTextConversion = false;
  primarychecked: number = 1;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private examService: ExamService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private domSanitizer: DomSanitizer,
    //public service : VoiceRecognitionService,
    private http: HttpClient
  ) {
   //this.service.init()
  }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('currentUser'));
    this.settings = JSON.parse(sessionStorage.pkshn_exam_set);
    this.studentName = this.userData['name'];
    this.studentCode = this.userData['code'];
    if (this.settings['submit'] == 0) {
      this.isSubmit = true;
    }
    if (this.settings['student_pause'] == 0) {
      this.isPauseBtn = true;
    }
    if (this.settings['text_speech'] == 0) {
      this.isSpeech = false;
    }
    if (this.settings['exam_logo'] != "") {
      this.ssclogo = this.settings['exam_logo'];
    }
    if (this.settings['text_conversion'] == 1) {
      this.isTextConversion = true;
    }
    // get return url from route parameters or default to '/'
    this.returnUrl = '/';

    /* call function for first question and exam info */
    this.getExams();
  }
  typingText: string = '';
  //typingStr: string = '';
  method(event) {
    //console.log(event.target.value);
    this.typingText = event.target.value;
  }
 display1 ='none'; //default  
  /* Get Exam data when exam UI is load */
  private getExams() {
    this.loading = true;
    this.spinner.show();
    this.options = [];
    this.questArr = [];
    this.answerdObj = {}; 
    this.examService.getTypingQuestion(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'])
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            let exam = data.exam_detail;
            this.question = exam.typing_text;     
            this.duration = exam.duration;
            this.counter(this.duration);
            this.spinner.hide();
          }
          else if (data.status == 'COM_TOKEN_ERROR') {
            this.loading = false;
            this.router.navigateByUrl('/login');
            this.spinner.hide();
          }
          else {
            this.loading = false;
            //this.router.navigateByUrl('/login');
            this.spinner.hide();
          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          //this.router.navigateByUrl('/login');
          this.spinner.hide();
        }
      );
  }

  totalTimeInSec = 0;
  currentTime = 0;
  /* Create timer according to duration */
  private counter(duration) {
    var chksec = duration.toString().split(".");
    var minutes = 0;
    var seconds = 0, digits = 0;
    // if (chksec.length > 1 && typeof chksec[1] != 'undefined') {
    //   seconds = parseInt(chksec[0]);
    //   digits = chksec[1].toString().length;
    //   if(minutes > 0)
    //   {
    //     if (digits == 1) {
    //       seconds = Math.round((parseInt(chksec[1]) / 10) * 60); 
    //     }
    //     else if (digits >= 2 && digits < 3) {
    //       seconds = Math.round((parseInt(chksec[1]) / 100) * 60); 
    //     }
    //     else {
    //       seconds = Math.round((parseInt(chksec[1]) / 1000) * 60); 
    //     }        
    //   }
    //   else{
    //     seconds = chksec[1];
    //   }
    // }
    //else {
      var seconds = parseInt(duration);
    //}

    this.totalTimeInSec = seconds; //minutes * 60;
    if (seconds >= 0) {
      this.interval = setInterval(() => {
        if (!this.isPause) {
          this.currentTime++;
          --seconds;
          //minutes = (seconds < 0) ? --minutes : minutes;
          seconds = (seconds < 0) ? 0 : seconds;
          if (seconds <= 10) {
            document.getElementById('timer-id').classList.add('blink_me');
          }
          if (seconds <= 0) {
            clearInterval(this.interval);
            sessionStorage.setItem('pkshn_exam_time', '0:0');
            this.openSubmitArea();
            this.submitFinalExam('auto');
            this.globals.isExamOver = true;
          }
          else{
            this.timershow = '' + seconds;
            this.totalExamTime = (duration - seconds);
            sessionStorage.setItem('pkshn_exam_time', this.timershow); 
          }
        }
      }, 1000);
    }
  }

  /* Pie chart */
  public openSubmitArea() {
    this.isDone = true;
    document.getElementById('question-area').style.display = 'none';
    document.getElementById('submited-area').style.display = 'block';
    document.getElementById('exit-test').style.display = 'none';
  }

  public submitFinalAnswer() { 
    if (this.settings['mandatory_exam'] == 1 && this.typingText == '') {
      this.mandatorySwal.show();
    }
    else if (this.settings['mandatory_exam'] == 0) {
      this.examsubmitconfirmSwal.show();
    } 
     else {
      this.examsubmitconfirmSwal.show();
     }
  }

  public submitFinalExam(submitType) {

    this.loading = true;
    if (submitType == 'auto') {
      this.autoSubmitAnswers('auto');
      this.isDone = false;
    }
    else {
      this.autoSubmitAnswers('manual');
      this.isDone = true;
    }


  }

  public autoSubmitAnswers(submitType) {
    this.spinner.show();
    //console.log(this.typingText); return;
    this.examService.submitTypingExam(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.typingText)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            this.globals.isExamOver = true;
            clearInterval(this.interval);
            sessionStorage.setItem('pkshn_exam_time', '0:0');
            if (submitType == 'manual') {
              //this.router.navigateByUrl('/login');
              document.getElementById('submited-area').style.display = 'none';
              document.getElementById('thanks-area').style.display = 'block';
            }
            else {
              document.getElementById('submited-area').style.display = 'none';
              document.getElementById('thanks-area').style.display = 'block';
            }
          }
          else {
            this.loading = false;
            // this.router.navigateByUrl('/login');
          }
          this.spinner.hide();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
          //this.router.navigateByUrl('/login');
        }
      );

  }
  public backFromFinalSubmit() {
    document.getElementById('question-area').style.display = 'block';
    document.getElementById('submited-area').style.display = 'none';
    document.getElementById('exit-test').style.display = 'block';
  }



  /* Go to full screen */
  public requestFullscreen(ele) {
    if (ele.requestFullscreen) {
      ele.requestFullscreen();
    } else if (ele.webkitRequestFullscreen) {
      ele.webkitRequestFullscreen();
    } else if (ele.mozRequestFullScreen) {
      ele.mozRequestFullScreen();
    } else if (ele.msRequestFullscreen) {
      ele.msRequestFullscreen();
    } else {
      console.log('Fullscreen API is not supported.');
    }
  };


   //myTimeout;
  /* Text to speech */
  public textToSpeech() {
    var navUserAgent = navigator.userAgent;
    let speechHtml = this.question + '. \n';
    for (var i = 0; i < this.options.length; ++i) {
      speechHtml += this.optionIndexText[i] + ' ? ';
      speechHtml += this.options[i].optiontext + '. \n';
    }
    speechSynthesis.cancel();
    var myTimeout = setTimeout(function () {
        speechSynthesis.pause();
        speechSynthesis.resume();
    }, 15000);     
    var msg = new SpeechSynthesisUtterance();
    var voices = window.speechSynthesis.getVoices(); //console.log(voices);
    for(var i = 0; i < voices.length ; i++) {
        if(voices[i].lang == 'hi-IN')
        {
            msg.voice = voices[i];
        }
    }       
    msg.volume = 1; // 0 to 1
    msg.rate = 1; // 0.1 to 10
    msg.pitch = 0; //0 to 2
    msg.text = speechHtml;
    msg.lang = this.speechLang; //hi-IN hindi india, en-GB great briten
    speechSynthesis.speak(msg);              
    msg.onend = function(e) {
      speechSynthesis.cancel();
      clearTimeout(myTimeout);
    }; 
  }
  public gotoHome() {
    sessionStorage.setItem('pkshn_exam_time','0:0');
    sessionStorage.removeItem("pkshn_exam_set");        
    sessionStorage.removeItem("pkshn_exam_time");       
    this.router.navigateByUrl('/login');
  } 
       
} 
